module.exports = __webpack_public_path__ + "static/MoodboardBerlinomania-ce178564c6fec42745b12b748a7f3fe0.webp";